<template>
	<v-container>
		<v-row v-if="product !== null">
			<v-col cols="12">
				<v-card flat>
					<v-card-title class="pb-0">
						{{ product.name }}
					</v-card-title>
				</v-card>
			</v-col>
			<v-col cols="12" md="6" lg="5">
				<v-card outlined>
					<v-card-text>
						<h3>Данные товара</h3>
						<v-divider class="my-2"/>
						<card-row title="Предлагаемое наименование">
<!--							todo сделать эту логику полностью на фронте-->
							{{ product.full_name }}
							<v-btn
								:loading="loadingSetFullName"
								small
								outlined
								@click="computeFullName"
							>
								Переименовать
							</v-btn>
						</card-row>
						<v-divider class="mb-2"/>
						<additional-vendor-codes
							:product="product"
							@changed="updateVendorCodes"
						/>
						<v-divider class="my-2"/>

						<h4>Цены</h4>
						<card-row title="Закуп">
							{{ product.prices.buy.value }} {{ product.prices.buy.currency }}
						</card-row>
						<card-row title="Продажа">
							{{ product.prices.sale.value }} {{ product.prices.sale.currency }}
						</card-row>

						<v-divider class="mb-2"/>

						<card-row title="Производитель">{{ product.manufacturer }}</card-row>
						<card-row title="Группа">{{ product.group_name }}</card-row>

						<v-divider class="mb-2"/>

						<h4>Доп. атрибуты</h4>
						<card-row
							v-for="attribute in product.attributes"
							:key="attribute.id"
							:title="attribute.name"
						>
							{{ parseValue(attribute.data.value) }}
						</card-row>
					</v-card-text>
					<v-card-actions>
						<v-btn
							v-if="$route.params.back"
							color="yellow"
							small
							outlined
							@click="$router.push($route.params.back)"
						>
							Назад
						</v-btn>
						<v-btn
							color="teal"
							small
							outlined
							@click="openMoySklad"
						>
							Открыть в МойСклад
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
			<v-col cols="12" md="6" lg="3">
				<v-card outlined>
					<v-card-text>
						<h3>Изображение</h3>
						<v-divider class="my-2"/>
						<v-img
							v-if="hasImage"
							:src="imageUrl"
							class="mb-5"
						/>
						<upload-image-modal
							:product-id="product.id"
							:activator-text="hasImage ? 'Изменить фото' : 'Добавить фото'"
							@uploaded="setImage"
						/>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="6" lg="4">
				<v-card outlined>
					<v-card-text>
						<h3>Машины</h3>
						<v-divider class="my-2"/>
						<product-machines
							:machines="product.machines"
							@add-machine="handleAddMachine"
						/>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import UploadImageModal from '@/components/products/show/upload-image-modal';
import CardRow from '@/components/base/card-row';
import Vue from 'vue';
import AdditionalVendorCodes from '@/components/products/show/additional-vendor-codes';
import ProductMachines from '@/components/products/show/product-machines';

const RELATIONS = ['additionalVendorCodes', 'attributes', 'media'];

export default {
	name: 'Show',
	components: {
		ProductMachines,
		AdditionalVendorCodes,
		CardRow,
		UploadImageModal,
	},
	data() {
		return {
			product: null,
			rightTab: null,
			loadingSetFullName: false,
			imagePlaceholderUrl: 'https://spaclean.ru/logo.png',
		};
	},
	computed: {
		hasImage() {
			return this.product.media.images !== null;
		},
		imageUrl() {
			if (!this.hasImage) {
				return this.imagePlaceholderUrl;
			}

			return this.product.media.images.url;
		},
	},
	async beforeRouteEnter(to, from, next) {
		try {
			const response = await Vue.prototype.$http.get(`/api/v2/products/${to.params.id}`, {
				params: {
					load: RELATIONS,
				},
			});
			next(vm => {
				vm.product = response.data.data
			});
		} catch (e) {
			next(false);
		}
	},
	mounted() {
	},
	methods: {
		openMoySklad() {
			window.open(this.product.moysklad_url, '_blank');
		},
		computeFullName() {
			if (this.loadingSetFullName) {
				return;
			}
			this.loadingSetFullName = true;
			this.setFullName()
				.finally(() => (this.loadingSetFullName = false));
		},
		parseValue(value) {
			if (typeof value === 'boolean') {
				return value ? 'Да' : 'Нет';
			}

			return value;
		},
		updateVendorCodes(vendorCodes) {
			this.product.additional_vendor_codes = vendorCodes;
		},
		setImage(imageObj) {
			this.product.media.images = imageObj;
		},
		async handleAddMachine(data) {
			console.log(data);
			try {
				await Vue.prototype.$http.put(`/api/v2/products/${this.product.id}/machines/${data.machine.id}`, {
					vendor_code: data.vendorCode,
				});
				const pivot = {
					machine: data.machine,
					vendor_code: data.vendorCode,
				};
				if (this.product.machines.some(mp => mp.machine.id === data.machine.id)) {
					this.product.machines = this.product.machines.map(mp => (mp.machine.id === data.machine.id) ? pivot : mp);
				} else {
					this.product.machines.push(pivot);
				}
			} catch (e) {
				this.$notify.error('Ошибка добавления машины');
			}
		},
	},
}
</script>

<style scoped>

</style>
